import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Autotext } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { BtnExtComponent } from "@app/utils/utils.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ConfirmComponent } from "@app/confirm/confirm.component"

@Component({
	selector: "app-insert-autotext",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		WysiwygComponent,
		LangValPipe,
		BtnExtComponent,
		ModalWrapComponent,
		ConfirmComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./insert-autotext.component.html",
})
export class InsertAutotextComponent extends Modalable {
	isModalOpen: boolean = false
	tableName: string = "autotexts"
	@Input() autotext: any = null //the autotext object to update
	autotexts: any[] = []
	isSaving: boolean = false
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		name: { not_empty: true, unique: true },
		html_autotext: { not_empty: true, unique: true },
	}

	ngOnInit() {
		console.log(this.autotext)

		if (!this.autotext) {
			this.autotext = new Autotext()
		}
		this.autotexts = this.store.getSiteDataTable(this.tableName)
	}
	validateAndSave(fieldName: string) {
		if (!this.autotext?.id) {
			return this.validateEntireForm()
		}
		this.validateEntireForm()
		this.saveField(fieldName)
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.autotext,
			this.errors,
			this.validationFields,
			this.autotexts
		)
	}

	async saveField(fieldName: string) {
		//save the autotext
		if (!this.isFormSubmittable) {
			return
		}

		const res: any = await this.apiService.save_gen_field(
			this.tableName,
			this.autotext.id,
			fieldName,
			this.autotext[fieldName]
		)
		if (res?.success) {
			this.store.updGenItemRowField(
				this.tableName,
				this.autotext.id,
				fieldName,
				this.autotext[fieldName]
			)
			this.modalService.openToast("update_successfuly")
		} else {
			this.modalService.openToast("save_failed")
		}
	}

	async save() {
		//save the contact
		if (!this.isFormSubmittable) {
			return
		}
		await this.apiService.sendApiGetPerms()
		if (
			!this.apiService.apiCallPerms ||
			!this.apiService.apiCallPerms[this.tableName]?.saveNewRow
		) {
			return
		}
		this.isSaving = true
		const res: any = await this.apiService.save_gen_item(this.tableName, {
			...this.autotext,
		})
		this.isSaving = false
		if (res.id) {
			this.autotext = res
			this.store.addGenItemRow(this.tableName, res)
			this.store.refreshTableSubject.next(this.tableName)
		}
		this.modalService.openToast(
			res?.id ? "saved_successfully" : res?.mes || "save_failed"
		)
		this.autotexts = this.store.getSiteDataTable(this.tableName)
	}
	async delete() {
		this.isSaving = true
		const res: any = await this.apiService.delete_gen_item(
			"autotexts",
			this.autotext.id
		)
		this.isSaving = false
		if (res.success) {
			this.store.delGenItemRow("autotexts", this.autotext.id)
			this.onClose.emit()
		}
	}
}
